module.exports = __webpack_public_path__ + "static/media/bhagyashree_patil.a67fdb12.png";